function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Perlo parama");

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 497 200",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 632,
    height: 200,
    style: {
      fill: "none"
    }
  }))), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    width: 297,
    height: 200,
    style: {
      fill: "#026670"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.3,
    width: 199.9,
    height: 199.7,
    style: {
      fill: "#f9ec4b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.5,98.3c-.1.1-.1.1-.2.1.1,0,.2,0,.2-.1",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.4,98.4h0",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.7,98.2a.1.1,0,0,0-.1.1l.1-.1",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5,57.7a17.52,17.52,0,0,0-7.3-6c-3.6-1.5-7.3-1.8-10.9-3.6-3.6-1.6-5.4-5.4-8.9-7.3a18.76,18.76,0,0,0-5-1.8c-4.6-.8-8.8.8-13.3-.2-3.9-1-7.2-3.4-11.2-3.9-1.1-.1-5.4-.1-6.5,0-4.1.5-7.3,2.9-11.2,3.9-4.6,1-8.8-.6-13.3.2a17.59,17.59,0,0,0-5,1.8c-3.6,2-5.4,5.7-8.9,7.3-3.6,1.8-7.3,2.1-10.9,3.6a17.66,17.66,0,0,0-7.3,6c-2.6,3.7-4.2,7.8-3.3,12.4,3.7,17.9,20,27.2,35,34.5l.5.2a2.92,2.92,0,0,0,.9.2,1.9,1.9,0,0,0,1.9-1.9,1.78,1.78,0,0,0-1-1.6h-.1c-.1,0-.1-.1-.2-.1-8.9-4.8-17.7-9.9-24.2-18.2-3.1-4.2-6-8.8-5.4-14.1A12.77,12.77,0,0,1,50.1,60c3.9-2,8.3-2.3,12.2-4.2,3.6-1.9,5.4-6,9.1-7.6,4.6-2.1,9.4-.3,14.3-.8,2.8-.2,5.2-1.6,7.6-2.8a17.54,17.54,0,0,1,5.9-1.4h1a13.8,13.8,0,0,1,5.9,1.4c2.4,1.1,4.9,2.6,7.6,2.8,4.9.5,9.8-1.3,14.3.8,3.7,1.6,5.5,5.7,9.1,7.6,3.9,2,8.3,2.3,12.2,4.2a13.06,13.06,0,0,1,6.2,9.1c.6,5.4-2.3,9.9-5.4,14.1-6.4,8.4-15.3,13.4-24.2,18.2-.1,0-.1.1-.2.1h-.1a1.78,1.78,0,0,0-1,1.6,1.9,1.9,0,0,0,1.9,1.9,2.92,2.92,0,0,0,.9-.2l.5-.2c15-7.3,31.2-16.6,35-34.5.9-4.6-.8-8.7-3.4-12.4",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3,83.8A20.7,20.7,0,1,0,120,104.5,20.68,20.68,0,0,0,99.3,83.8m.6,35.3a15.7,15.7,0,1,1,15.7-15.7,15.66,15.66,0,0,1-15.7,15.7",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.7,90.1h-.1a1.72,1.72,0,0,1-1.6-1.9,1.72,1.72,0,0,1,.8-1.4l.8-.6c4-2.9,6.8-5,10.5-7.7a3.32,3.32,0,0,1,1.6-.5h0a2.48,2.48,0,0,1,2.2,2.7,2.77,2.77,0,0,1-1.3,2l-1.3.8c-2.9,1.7-5.8,3.4-8.8,5.1l-2,1.2a1.14,1.14,0,0,1-.8.3m.5-1.3h0m-.9-1.1Z",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.4,81.8a1.79,1.79,0,0,1-1.8-1.8,1.27,1.27,0,0,1,.1-.6l.3-.7c1.6-2.8,2.8-5.3,4.2-7.9.8-1.6,1.6-3.2,2.5-4.9a2.21,2.21,0,0,1,2-1.1h0a2.19,2.19,0,0,1,1.7.7,2.5,2.5,0,0,1,.8,1.8,2.82,2.82,0,0,1-.4,1.5c-1.9,2.9-3.8,5.9-5.8,9L114,81a2.25,2.25,0,0,1-1.6.8Zm.6-1.6Z",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7,75.7c-.2-2.9-.3-7-.5-10.4-.1-3-.2-5.6-.3-6.4v-.4a2.93,2.93,0,0,1,2.9-3,2.86,2.86,0,0,1,2.8,2.8v.8h0c-.3,6.2-.5,9.9-.7,12.4-.1,1.8-.2,3-.2,4.2a2.11,2.11,0,0,1-2.1,2.1,2.35,2.35,0,0,1-1.9-2.1",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1,89l-2-1.2c-2.9-1.7-5.8-3.3-8.7-5.1L68.1,82a2.4,2.4,0,0,1-1.2-2,2.48,2.48,0,0,1,2.2-2.7h0a2.52,2.52,0,0,1,1.6.5c3.7,2.7,6.5,4.8,10.4,7.7l.8.6a1.83,1.83,0,0,1,.8,1.3,2,2,0,0,1-.4,1.3,1.43,1.43,0,0,1-1.2.6H81l-.9-.3m.4-1h0m.9-1.1Z",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.2,81a1.72,1.72,0,0,1-1.4-.8l-2-3.2c-1.9-3.1-3.9-6-5.7-8.9a2.3,2.3,0,0,1-.4-1.4,2.5,2.5,0,0,1,.8-1.8,2.61,2.61,0,0,1,1.7-.7h0a2.4,2.4,0,0,1,1.9,1.1c.9,1.7,1.7,3.3,2.5,4.8,1.3,2.5,2.6,5,4.1,7.8l.3.6a1.27,1.27,0,0,1,.1.6A2,2,0,0,1,86.2,81Zm-.5-1.6Z",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.6,143.6a1.85,1.85,0,0,0,.2-1.9,1.64,1.64,0,0,0-2.2-.9,1.44,1.44,0,0,1-.3.2c-15.4,10.4-25.6,17.6-48.4,17.6-19.8,0-30.7-4.8-48.9-17.6,0,0-.2-.2-.3-.2a1.73,1.73,0,0,0-2.2.9,1.83,1.83,0,0,0,.2,1.9h0c10.5,10.6,25.1,22.3,51,22.3,27.4-.1,39.6-11,50.9-22.3h0",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.8,117.5c-8.7-5-18-6.9-27.4-9h-.3a1.58,1.58,0,0,0-1.6,1.6,1.62,1.62,0,0,0,1.4,1.6h0a110.37,110.37,0,0,1,17.7,4.8c3.4,1.4,6.7,2.9,9.2,5.9,1.1,1.4,1.8,3.1,1,4.8s-2.6,2.4-4.3,2.6a19.84,19.84,0,0,1-9.3-1.8,12.25,12.25,0,0,0-4.2-1.4c-4.2-.8-7.2,2.1-10.6,4.2s-6.1,3.5-9.8,4.2a14.77,14.77,0,0,1-6.9-1.1c-4.2-1.6-8.3-3.6-12.8-3.8H99.1c-4.5.4-8.5,2.3-12.8,3.8a14.77,14.77,0,0,1-6.9,1.1c-3.7-.6-6.5-2.2-9.8-4.2s-6.4-5-10.6-4.2a16,16,0,0,0-4.2,1.4,21.16,21.16,0,0,1-9.3,1.8c-1.8-.2-3.5-.8-4.3-2.6a4.31,4.31,0,0,1,1-4.8c2.4-3.1,5.8-4.5,9.2-5.9a105,105,0,0,1,17.7-4.8h0a1.62,1.62,0,0,0,1.4-1.6,1.58,1.58,0,0,0-1.6-1.6h-.3c-9.5,2.1-18.8,4-27.4,9a12.32,12.32,0,0,0-6.6,10.8,9.45,9.45,0,0,0,6.1,8.2c5.5,1.9,11.4.5,16.5-2.1,1.8-.8,3.5-.2,5.1,1,5.8,3.9,11.6,7.9,18.6,7.2,5-.5,9.2-3.1,14-4.3a15.23,15.23,0,0,1,4.2-.6h1.8a15.23,15.23,0,0,1,4.2.6c4.8,1.3,9,3.9,14,4.3,7.1.6,12.8-3.4,18.6-7.2,1.6-1.1,3.4-1.8,5.1-1,5.1,2.6,11.1,4,16.5,2.1a9.45,9.45,0,0,0,6.1-8.2,12.21,12.21,0,0,0-6.6-10.8",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.6,98.1c-.1.1-.1.1-.2.1.1,0,.2,0,.2-.1",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.5,98.3h0",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.8,98a.1.1,0,0,0-.1.1l.1-.1",
    style: {
      fill: "#026670"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.56,86.77v22.74H247.17V47.33h25.36c14.84,0,22.74,7.72,22.74,19.76s-7.9,19.68-22.65,19.68Zm0-28v16.7h12.75c6.75,0,10.26-2.75,10.26-8.35s-3.51-8.35-10.26-8.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.38,87.92a31.55,31.55,0,0,1-.23,3.91H312.64c1.24,6.22,5.6,8.93,11.06,8.93a17.4,17.4,0,0,0,10.88-4.13l6.8,7.46c-4.89,4.49-11.11,6.53-18.35,6.53-13.19,0-22.34-9-22.34-22.52s8.88-22.78,21.77-22.78C334.85,65.32,343.33,74.51,343.38,87.92Zm-30.7-4h19.06c-1.07-5.51-4.4-8.62-9.37-8.62C316.9,75.31,313.71,78.6,312.68,83.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24,66.25l-1.73,11.5a18.88,18.88,0,0,0-7-1.37c-5.37,0-9.06,3.28-9.06,9.68v23.45H352.84v-43h11.24v4.71c2.71-4,6.84-5.86,12.12-5.86A17.54,17.54,0,0,1,382.24,66.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.74,109.51H390.15v-64h11.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.8,88c0,13-9.91,22.65-23.32,22.65S411.25,100.94,411.25,88s9.86-22.65,23.23-22.65S457.8,75,457.8,88Zm-34.74,0c0,7,4.89,11.86,11.42,11.86S445.94,94.94,445.94,88,441,76.11,434.48,76.11,423.06,81,423.06,88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.85,145.45V157H244.1V127.57h11.42c6.79,0,10.43,3.43,10.43,8.94s-3.64,8.94-10.43,8.94Zm0-13.4V141h6.54c3.85,0,5.61-1.43,5.61-4.46s-1.76-4.46-5.61-4.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1,157h-4.4v-2.42a7.64,7.64,0,0,1-6.33,2.95c-5.63,0-10.07-4.44-10.07-10.6s4.44-10.6,10.07-10.6a7.66,7.66,0,0,1,6.33,3v-2.44h4.4Zm-16.28-10.07c0,3.53,2.29,6.46,6.08,6.46s6.07-2.78,6.07-6.46-2.43-6.46-6.07-6.46S273.82,143.41,273.82,146.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.57,136.91l-1.05,4.35a8,8,0,0,0-3.35-.73c-2.79,0-4.79,2-4.79,5.4V157H297V136.87h4.36v2.27a6.72,6.72,0,0,1,5.84-2.8A8.79,8.79,0,0,1,310.57,136.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,157h-4.39v-2.42a7.64,7.64,0,0,1-6.33,2.95c-5.64,0-10.07-4.44-10.07-10.6s4.43-10.6,10.07-10.6a7.66,7.66,0,0,1,6.33,3v-2.44h4.39Zm-16.27-10.07c0,3.53,2.29,6.46,6.07,6.46s6.08-2.78,6.08-6.46-2.44-6.46-6.08-6.46S317.27,143.41,317.27,146.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,144.35V157h-4.41V145.8c0-3.38-1.75-5.27-4.69-5.27a5,5,0,0,0-5.21,5.32V157h-4.42V145.8c0-3.38-1.75-5.27-4.69-5.27a5,5,0,0,0-5.21,5.32V157h-4.42V136.87h4.37v2.46a7.16,7.16,0,0,1,6.19-3,7.94,7.94,0,0,1,7,3.6c1.74-2.88,4.85-3.6,7.35-3.6C370.1,136.34,373.48,139.64,373.48,144.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5,157h-4.39v-2.42a7.64,7.64,0,0,1-6.33,2.95c-5.64,0-10.07-4.44-10.07-10.6s4.43-10.6,10.07-10.6a7.66,7.66,0,0,1,6.33,3v-2.44h4.39Zm-16.27-10.07c0,3.53,2.29,6.46,6.07,6.46s6.08-2.78,6.08-6.46-2.44-6.46-6.08-6.46S383.23,143.41,383.23,146.94Z",
    style: {
      fill: "#fff"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.ebe060d2.svg";
export { ForwardRef as ReactComponent };